import React from 'react';

import Button from 'components/button';
import Header from 'components/header';

import { useMeQuery } from 'hooks/auth';
import { useAuth } from 'context/auth';

import style from './style.module.css';

const HeaderAdmin = () => {
  const { logout } = useAuth();
  const { data } = useMeQuery();
  const { me = {} } = data || {};
  const { role } = me;

  const routes = [
    {
      text: 'home',
      path: '/admin/home',
    },
    {
      text: 'info',
      path: '/admin/info',
    },
    {
      text: 'approach',
      path: '/admin/approach',
    },
    {
      text: 'projects',
      path: '/admin/projects',
    },
  ];

  if (role === 'ADMIN') {
    routes.push({
      text: 'media',
      path: '/admin/media',
    });
    routes.push({
      text: 'users',
      path: '/admin/users',
    });
    routes.push({
      text: 'activity',
      path: '/admin/activity',
    });
  }

  return (
    <Header routes={routes}>
      <Button onClick={logout} className={style.logout}>
        Log Out
      </Button>
    </Header>
  );
};

export default HeaderAdmin;
